import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { convertToUpperCase } from 'helper';

const TaxPayerInformation = ({ data }) => {
  return (
    <>
      <div className="row d-flex align-items-center mb-1">
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              First Name
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {convertToUpperCase(_.get(data, 'attributes.first_name'))}
            </span>
          </div>
        </div>

        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Resident ID
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {_.get(data, 'attributes.official_resident_id_number') || '--'}
            </span>
          </div>
        </div>
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Middle Name
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text">
              {convertToUpperCase(_.get(data, 'attributes.middle_name'))}
            </span>
          </div>
        </div>
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Residency Status
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {_.get(data, 'attributes.is_resident') ? 'YES' : 'NO'}
            </span>
          </div>
        </div>
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Last Name
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text">
              {convertToUpperCase(_.get(data, 'attributes.last_name'))}
            </span>
          </div>
        </div>
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Birth Date
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {_.get(data, 'attributes.birth_date') || '--'}
            </span>
          </div>
        </div>
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Extension Name
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text">
              {convertToUpperCase(_.get(data, 'attributes.extension_name'))}
            </span>
          </div>
        </div>
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Sex
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text">
              {convertToUpperCase(
                _.get(data, 'attributes.sex') || _.get(data, 'attributes.gender')
              )}
            </span>
          </div>
        </div>

        <div className="col-12">
          <hr className="cit-hr" />
        </div>
        <>
          <div className="col-12 mt-1">
            <div className="cit-inner">
              <label className="font-weight-bold mb-0 mr-2 cit-label--lg">
                Email
              </label>
              <span className="cit-span--lg">:</span>
              <span className="transaction-text p-0">
                {_.get(data, 'attributes.email') || '--'}
              </span>
            </div>
          </div>
          <div className="col-12 mt-1">
            <div className="cit-inner">
              <label className="font-weight-bold mb-0 mr-2 cit-label--lg">
                Mobile Number
              </label>
              <span className="cit-span--lg">:</span>
              <span className="transaction-text">
                {_.get(data, 'attributes.mobile_number') || '--'}
              </span>
            </div>
          </div>
        </>
        <div className="col-12 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label--lg">
              Account Status
            </label>
            <span className="cit-span--lg">:</span>
            <span className="transaction-text">
              {_.get(data, 'attributes.is_active') ? 'ACTIVE' : 'INACTIVE'}
            </span>
          </div>
        </div>
        <div className="col-12 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label--lg">
              Resident Address
            </label>
            <span className="cit-span--lg">:</span>
            <span className="transaction-text p-0">
              {_.get(data, 'attributes.street') || '--'},{' '}
              {_.get(data, 'attributes.barangay_name') || '--'},{' '}
              {_.get(data, 'attributes.municipality_name') || '--'},{' '}
              {_.get(data, 'attributes.province_name') || '--'},{' '}
              {_.get(data, 'attributes.region_name') || '--'}
            </span>
          </div>
        </div>
        <div className="col-12 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label--lg">
              Place of Birth
            </label>
            <span className="cit-span--lg">:</span>
            <span className="transaction-text p-0">
              {_.get(data, 'attributes.place_of_birth_municipality_name') ||
                '--'},{' '}
              {_.get(data, 'attributes.place_of_birth_province_name') || '--'},{' '}
              {_.get(data, 'attributes.place_of_birth_region_name') || '--'}
            </span>
          </div>
        </div>
        <div className="col-12 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label--lg">
              Verification Status
            </label>
            <span className="cit-span--lg">:</span>
            <span className="transaction-text">
              {_.get(data, 'attributes.verification_status')}
            </span>
          </div>
        </div>
        <div className="col-12 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label--lg">
              Verified At
            </label>
            <span className="cit-span--lg">:</span>
            <span className="transaction-text">
              {_.get(data, 'attributes.verified_at')}
            </span>
          </div>
        </div>
        <div className="col-12 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label--lg">
              Verification Remarks
            </label>
            <span className="cit-span--lg">:</span>
            <span className="transaction-text">
              {_.get(data, 'attributes.verification_remarks')}
            </span>
          </div>
        </div>
        <div className="col-12 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label--lg">
              Valid ID
            </label>
            <span className="cit-span--lg">:</span>
            <span className="transaction-text">
              <img
                src={_.get(data, 'attributes.valid_id_url')}
                className="img-responsive image-wrapper"
                alt="Empty State"
              />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

TaxPayerInformation.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default TaxPayerInformation;
